/* Shopify renders the cards and their recommendation tracking URLs. */
(() => {
  if (customElements.get('product-recommendations')) return;
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded === 'true' || this.controller) return;
      if (this.querySelector('[data-recommendations-content]')) {
        this.dataset.loaded = 'true';
        return;
      }
      if (!this.dataset.url || !this.dataset.productId || !this.dataset.sectionId) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.load(signal);
        }, { rootMargin: '500px 0px' });
        this.observer.observe(this);
      } else this.load(signal);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
      this.loading = false;
    }
    async load(signal) {
      if (this.loading || signal.aborted) return;
      this.loading = true;
      this.setAttribute('aria-busy', 'true');
      try {
        const url = new URL(this.dataset.url, document.baseURI);
        url.searchParams.set('product_id', this.dataset.productId);
        url.searchParams.set('section_id', this.dataset.sectionId);
        url.searchParams.set('limit', this.dataset.limit || '5');
        url.searchParams.set('intent', 'related');
        const response = await fetch(url, { signal, headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error('Recommendations unavailable');
        const html = await response.text();
        if (signal.aborted || !this.isConnected) return;
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const content = parsed.querySelector('[data-recommendations-content]');
        if (content?.querySelector('.product-card')) {
          this.replaceChildren(document.importNode(content, true));
          this.hidden = false;
        } else this.hidden = true;
        this.dataset.loaded = 'true';
      } catch {
        if (signal.aborted) return;
        // Optional recommendations fail closed without a blank title or fictitious cards.
        this.hidden = true;
        this.dataset.loaded = 'true';
      } finally {
        if (this.controller?.signal === signal) {
          this.loading = false;
          this.removeAttribute('aria-busy');
        }
      }
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);
})();
